<template>
  <div class="wrapper">
    <div
      class="bg"
      v-for="(img, index) in images"
      :key="index"
      :style="{ backgroundImage: `url(${img})` }"
      :class="{ active: activeIndex === index }"
    ></div>
    <div class="loginDiv">
      <div class="login">
        <p class="loginTitle">请登录</p>
        <el-form
          :model="form"
          :rules="rules"
          ref="formRef"
          label-position="top"
        >
          <el-form-item prop="username" label="登录账号">
            <el-input v-model="form.username" placeholder="请输入您的账号">
              <template #prefix>
                <!-- <img
                  src="@/assets/images/Login/userName.png"
                  alt=""
                  class="prefix"
                /> -->
                <el-icon :size="18"><User /></el-icon> </template
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" label="账号密码">
            <el-input
              type="password"
              v-model="form.password"
              placeholder="请输入您的密码"
              show-password
            >
              <template #prefix>
                <!-- <img
                  src="@/assets/images/Login/password.png"
                  alt=""
                  class="prefix"
                /> -->
                <el-icon :size="18"><Lock /></el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom">
        <el-button class="elbutton" @click="clickLogin">登录</el-button>
        <span class="register">
          <span class="pointer" @click="register()">注册账户</span></span
        >
      </div>
    </div>
    <div class="topTitle">
      <img src="@/assets/images/Login/logo.png" alt="" />
      <div class="title">
        <p class="p1">国家病原微生物实验室管理服务平台</p>
        <!-- <p class="p2">
          National Pathogenic Microorganism Laboratory Management Service Platform
        </p> -->
      </div>
    </div>
    <p class="Copyright">
      Copyright © National Health Commission of the People's Republic of China |
      京ICP备10218182号-30
    </p>
    <p class="version">
      <span>版本：{{ version }} |</span>
      <img src="@/assets/images/Login/versionBg.png" />
    </p>
    <Verify
      @success="verifySuccess"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verifyref"
    />
    <checkEmail @changeSuc="submitLogin" ref="checkEmailref" />
  </div>
</template>

<script  setup name="login">
import CryptoJS from "crypto-js";
import { login, getDictType, sendEmail } from "@/api/user";
import router from "@/router";
import { onMounted, ref, onBeforeUnmount } from "vue";
import Verify from "./Verifition/Verify";
import checkEmail from "./checkEmail";
import showMessage from "@/utils/message";

const version = ref("");
const images = ref([]);
const form = ref({
  username: "",
  password: "",
});
const rules = ref({
  username: [
    {
      required: true,
      message: "请输入用户名",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
});
onMounted(() => {
  getVersionDict();
  getBgDict();
  localStorage.removeItem("Token");
  localStorage.removeItem("token_type");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("username");
  localStorage.removeItem("deptName");
  localStorage.removeItem("userId");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("roleIdArea");
  localStorage.removeItem("name");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refresh_token");
  sessionStorage.removeItem("tenantId");
  var d = new Date();
  d.setTime(d.getTime());
  var expires = "expires=" + d.toUTCString();
  document.cookie = "token" + "=" + null + ";" + expires + ";path=/";
  document.cookie = "refresh_token" + "=" + null + ";" + expires + ";path=/";
  document.cookie = "tenantId" + "=" + null + ";" + expires + ";path=/";
});

/* 渐变start */
const activeIndex = ref(0);
let intervalId = null;

// 预加载图片
const preloadImages = () => {
  let loaded = 0;
  images.value.forEach((img) => {
    const imgObj = new Image();
    imgObj.onload = () => {
      if (++loaded === images.value.length) {
        console.log("所有图片预加载完成");
      }
    };
    imgObj.src = img;
  });
};

// 切换背景
const switchBackground = () => {
  activeIndex.value = (activeIndex.value + 1) % images.value.length;
};
/* 渐变end */

async function getVersionDict() {
  const { data } = await getDictType({ type: "version" });
  version.value = data[data.length - 1].label;
}

// 获取背景图
async function getBgDict() {
  const { data } = await getDictType({ type: "background" });
  images.value = data.map(
    (item) => "/api/admin/sys-file/oss/file?fileName=" + item.value
  );
  preloadImages();
  intervalId = setInterval(switchBackground, 5000);
}

function register() {
  router.push("/register");
}
const formRef = ref(null);

const verifyref = ref(null);
function clickLogin() {
  localStorage.removeItem("Token");
  localStorage.removeItem("token_type");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("username");
  localStorage.removeItem("deptName");
  localStorage.removeItem("userId");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("roleIdArea");
  localStorage.removeItem("name");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refresh_token");
  sessionStorage.removeItem("tenantId");
  var d = new Date();
  d.setTime(d.getTime());
  var expires = "expires=" + d.toUTCString();
  document.cookie = "token" + "=" + null + ";" + expires + ";path=/";
  document.cookie = "refresh_token" + "=" + null + ";" + expires + ";path=/";
  document.cookie = "tenantId" + "=" + null + ";" + expires + ";path=/";
  formRef.value.validate((valid) => {
    if (valid) {
      if (window.Verifition) {
        verifyref.value.show();
      } else {
        const val = {
          captchaVerification: "",
        };
        if (window.expertVerifition) {
          submitSendEmail(val);
        } else {
          submitLogin(val);
        }
      }
    } else {
      return false;
    }
  });
}
function verifySuccess(val) {
  if (window.expertVerifition) {
    submitSendEmail(val);
  } else {
    submitLogin(val);
  }
}
const checkEmailref = ref(null);

async function submitSendEmail(val) {
  const keyWord = "pigxpigxpigxpigx";
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  // 加密
  var encrypted = CryptoJS.AES.encrypt(form.value.password, key, {
    iv: key,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  }).toString();
  const qureyform = {
    username: form.value.username,
    password: encrypted,
  };
  const res = await sendEmail(qureyform);

  if (res.code == 0 && res.data == null) {
    submitLogin(val);
  } else if (res.code == 0 && res.data != null) {
    checkEmailref.value.open(form.value, res.data, val);
  } else {
    showMessage.error(res.msg || res.msg);
  }
}
async function submitLogin(val) {
  const keyWord = "pigxpigxpigxpigx";
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  // 加密
  var encrypted = CryptoJS.AES.encrypt(form.value.password, key, {
    iv: key,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  }).toString();
  const qureyform = {
    username: form.value.username,
    password: encrypted,
    code: val.captchaVerification,
  };
  const res = await login(qureyform);
  if (res.access_token) {
    localStorage.setItem("Token", res.access_token);
    localStorage.setItem("token_type", res.token_type);
    localStorage.setItem("refresh_token", res.refresh_token);
    sessionStorage.setItem("token", JSON.stringify(res.access_token));
    sessionStorage.setItem("refresh_token", JSON.stringify(res.refresh_token));
    sessionStorage.setItem("tenantId", JSON.stringify(1));
    var d = new Date();
    d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie =
      "token" + "=" + res.access_token + ";" + expires + ";path=/";
    document.cookie =
      "refresh_token" + "=" + res.access_token + ";" + expires + ";path=/";
    document.cookie = "tenantId" + "=" + 1 + ";" + expires + ";path=/";
    router.push("/home");
  } else {
    showMessage.error(res.msg);
  }
}

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId);
});
</script>
<style lang='scss' scoped>
.wrapper {
  height: 100%;
  width: 100%;
  // background: url("@/assets/images/Login/newBc.png") no-repeat;
  // background-size: 100% 100%;
  position: relative;

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 2s ease-in-out;
    &.active {
      opacity: 1;
    }
  }
}

.loginDiv {
  position: absolute;
  right: 5vw;
  top: 25vh;
  padding: 35px 50px;
  width: 25%;
  min-width: 300px;
  max-width: 400px;
  height: 40vh;
  min-height: 330px;
  background: #fff;
  border-radius: 25px 25px 25px 25px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .loginTitle {
    padding: 26px 0;
    color: #333;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: 0.2em;
  }
  .elbutton {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    height: 40px;
    background-color: #0830c3;
    border: 0;
    color: #ffffff;
    border-radius: 10px;
    letter-spacing: 0.2em;
  }
  .register {
    margin-top: 20px;
    padding-top: 10px;
    display: block;
    text-align: center;
    color: #0830c3;
    font-size: 16px;
    width: 100%;
  }
  .pointer {
    cursor: pointer;
  }
}
.topTitle {
  position: absolute;
  top: 3vh;
  left: 3vw;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  line-height: 3vh;
  img {
    height: 6vh;
    width: 6vh;
  }
  .title {
    padding-left: 1vw;
    .p1 {
      font-size: 4vh;
      // padding-bottom: 0.5vh;
      font-weight: bold;
      letter-spacing: 0.5em;
      line-height: 5vh;
    }
    .p2 {
      font-size: 2vh;
    }
  }
}
.prefix {
  height: 13px;
}
:deep(.el-form-item__label) {
  // color: #fff !important;
  font-size: 14px;
}
:deep(.el-form-item__content) {
  width: 100%;
  text-align: center;
}

:deep(.el-input__wrapper) {
  color: #fff !important;
  background: transparent;
  box-shadow: 0px 0px 0px 1px #d3d5f8;
}
:deep(.el-input__inner) {
  color: #000 !important;
  background: transparent;
  background-color: transparent !important;
  font-weight: 500;
}
:deep(
    input:-webkit-autofill,
    textarea:-webkit-autofill,
    select:-webkit-autofill
  ) {
  -webkit-text-fill-color: #000 !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: rgba(69, 110, 223, 0.73);
  background-image: none;
  color: #d3d5f8 !important;
  transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
}
:deep(.el-input__inner:-webkit-autofill) {
  -webkit-text-fill-color: #000 !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: rgba(69, 110, 223, 0.73);
  background-image: none;
  color: #d3d5f8 !important;
  transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
}
.Copyright {
  position: absolute;
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  bottom: 10px;
  letter-spacing: 0.08em;
}
.version {
  opacity: 0.8;
  font-family: versionFont;
  position: absolute;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  bottom: 10px;
  right: 20px;
  letter-spacing: 0.08em;
}
</style>